module.exports = __webpack_public_path__ + "static/media/two_red_triangle.e5f9f5a5.svg";